import React from 'react';
// import { useState } from 'react'; // Unused import removed
import { useNavigate } from 'react-router-dom';
import { getAllIndustries } from '../data/industries.js';

const Industries = () => {
  const navigate = useNavigate();
  const industries = getAllIndustries();
  // const [hoveredIndustry, setHoveredIndustry] = useState(null); // Unused variable removed

  // Black and sky blue color scheme
  const industryBranding = {
    healthcare: {
      primaryColor: '#000000',
      secondaryColor: '#0ea5e9',
      gradient: '#000000',
      icon: 'bi-heart-pulse',
      projects: 2,
      successRate: '95%',
      avgROI: '40%'
    },
    banking: {
      primaryColor: '#000000',
      secondaryColor: '#0ea5e9',
      gradient: '#000000',
      icon: 'bi-bank',
      projects: 3,
      successRate: '98%',
      avgROI: '35%'
    },
    retail: {
      primaryColor: '#000000',
      secondaryColor: '#0ea5e9',
      gradient: '#000000',
      icon: 'bi-shop',
      projects: 1,
      successRate: '92%',
      avgROI: '45%'
    },
    transport: {
      primaryColor: '#000000',
      secondaryColor: '#0ea5e9',
      gradient: '#000000',
      icon: 'bi-truck',
      projects: 2,
      successRate: '90%',
      avgROI: '50%'
    },
    cybersecurity: {
      primaryColor: '#000000',
      secondaryColor: '#0ea5e9',
      gradient: '#000000',
      icon: 'bi-shield-check',
      projects: 3,
      successRate: '99%',
      avgROI: '60%'
    },
    education: {
      primaryColor: '#000000',
      secondaryColor: '#0ea5e9',
      gradient: '#000000',
      icon: 'bi-mortarboard',
      projects: 2,
      successRate: '95%',
      avgROI: '55%'
    }
  };

  return (
    <section id="industries" className="industries-section py-5" style={{
      background: 'linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)',
      position: 'relative',
      overflow: 'hidden',
      padding: '6rem 0'
    }}>
      {/* Background Pattern */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: `
          radial-gradient(circle at 20% 80%, rgba(14, 165, 233, 0.08) 0%, transparent 50%),
          radial-gradient(circle at 80% 20%, rgba(14, 165, 233, 0.06) 0%, transparent 50%)
        `,
        zIndex: 1
      }}></div>

      <div className="container" style={{ position: 'relative', zIndex: 2 }}>
        <div className="row justify-content-center text-center mb-5">
          <div className="col-lg-8" style={{
            margin: '0 auto',
            textAlign: 'center',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center'
          }}>

            <h2 className="section-title" style={{
              fontSize: 'clamp(2rem, 4vw, 3rem)',
              fontWeight: '900',
              marginBottom: '1rem',
              lineHeight: '1.2'
            }}>
              <span style={{ color: '#000000' }}>Industries</span>{' '}
              <span style={{ 
                background: 'linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text'
              }}>We Serve</span>
            </h2>
            <p className="section-subtitle" style={{
              fontSize: '1.2rem',
              color: '#64748b',
              lineHeight: '1.6',
              maxWidth: '600px',
              margin: '0 auto'
            }}>Specialized solutions with tangible use-cases across diverse sectors</p>
          </div>
        </div>
        
        <div className="row g-3 g-md-4">
          {industries.map((industry) => {
            const branding = industryBranding[industry.id] || industryBranding.healthcare;
            return (
              <div key={industry.id} className="col-12 col-sm-6 col-lg-4">
                <div 
                  className="industry-card-modern"
                  style={{
                    background: 'rgba(255, 255, 255, 0.9)',
                    backdropFilter: 'blur(20px)',
                    borderRadius: 'clamp(16px, 3vw, 24px)',
                    padding: 'clamp(1rem, 3vw, 2rem)',
                    textAlign: 'left',
                    border: '1px solid rgba(14, 165, 233, 0.2)',
                    boxShadow: '0 8px 30px rgba(0, 0, 0, 0.06)',
                    transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
                    cursor: 'pointer',
                    height: '100%',
                    position: 'relative',
                    overflow: 'hidden',
                    minHeight: 'clamp(350px, 60vh, 450px)',
                    display: 'flex',
                    flexDirection: 'column'
                  }}
                  onClick={() => navigate(`/industries/${industry.id}`)}
                  onMouseEnter={(e) => {
                    // setHoveredIndustry(industry.id); // Removed unused variable
                    e.currentTarget.style.transform = 'translateY(-8px)';
                    e.currentTarget.style.boxShadow = '0 25px 50px rgba(14, 165, 233, 0.15)';
                    e.currentTarget.style.borderColor = 'rgba(14, 165, 233, 0.4)';
                  }}
                  onMouseLeave={(e) => {
                    // setHoveredIndustry(null); // Removed unused variable
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = '0 8px 30px rgba(0, 0, 0, 0.06)';
                    e.currentTarget.style.borderColor = 'rgba(14, 165, 233, 0.2)';
                  }}
                >
                  {/* Background Pattern */}
                  <div style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    background: `
                      radial-gradient(circle at 30% 20%, rgba(14, 165, 233, 0.05) 0%, transparent 50%),
                      radial-gradient(circle at 70% 80%, rgba(14, 165, 233, 0.03) 0%, transparent 50%)
                    `,
                    zIndex: 1
                  }}></div>

                  <div style={{ 
                    position: 'relative', 
                    zIndex: 2,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 'clamp(0.75rem, 2vw, 1rem)',
                    height: '100%',
                    flex: 1
                  }}>
                    {/* Row 1: Icon + Title - Combined in one line */}
                    <div style={{
                      minHeight: 'clamp(40px, 6vw, 60px)',
                      display: 'flex',
                      alignItems: 'center',
                      gap: 'clamp(0.5rem, 2vw, 1rem)',
                      flexShrink: 0
                    }}>
                      <div style={{
                        width: 'clamp(40px, 6vw, 50px)',
                        height: 'clamp(40px, 6vw, 50px)',
                        background: 'linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%)',
                        borderRadius: 'clamp(8px, 2vw, 12px)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: 'clamp(1.2rem, 3vw, 1.5rem)',
                        boxShadow: '0 4px 15px rgba(14, 165, 233, 0.3)',
                        flexShrink: 0
                      }}>
                        <i className={`bi ${branding.icon}`} style={{ color: 'white' }}></i>
                      </div>
                      <h3 style={{
                        fontSize: 'clamp(1rem, 2.5vw, 1.2rem)',
                        fontWeight: '700',
                        color: '#1e293b',
                        margin: 0,
                        lineHeight: '1.3'
                      }}>
                        {industry.title}
                      </h3>
                    </div>

                    {/* Row 2: Industry Subtitle */}
                    <div style={{
                      minHeight: 'clamp(25px, 4vw, 35px)',
                      display: 'flex',
                      alignItems: 'center',
                      flexShrink: 0
                    }}>
                      <p style={{
                        color: '#0ea5e9',
                        fontWeight: '600',
                        fontSize: 'clamp(0.8rem, 2vw, 0.9rem)',
                        margin: 0
                      }}>
                        {industry.subtitle}
                      </p>
                    </div>

                    {/* Row 3: Industry Description */}
                    <div style={{
                      flex: 1,
                      display: 'flex',
                      alignItems: 'flex-start',
                      minHeight: 'clamp(60px, 12vw, 80px)'
                    }}>
                      <p style={{
                        color: '#64748b',
                        lineHeight: '1.6',
                        fontSize: 'clamp(0.8rem, 2vw, 0.9rem)',
                        margin: 0
                      }}>
                        {industry.overview}
                      </p>
                    </div>

                    {/* Row 4: Project Success Metrics */}
                    <div style={{
                      minHeight: 'clamp(50px, 10vw, 70px)',
                      display: 'flex',
                      alignItems: 'center',
                      flexShrink: 0
                    }}>
                      <div style={{
                        display: 'grid',
                        gridTemplateColumns: '1fr 1fr',
                        gap: 'clamp(0.5rem, 2vw, 1rem)',
                        width: '100%'
                      }}>
                        <div style={{
                          background: 'rgba(14, 165, 233, 0.08)',
                          border: '1px solid rgba(14, 165, 233, 0.2)',
                          borderRadius: 'clamp(8px, 2vw, 12px)',
                          padding: 'clamp(0.75rem, 2vw, 1rem)',
                          textAlign: 'center'
                        }}>
                          <div style={{
                            fontSize: 'clamp(1rem, 2.5vw, 1.1rem)',
                            fontWeight: '700',
                            color: '#0ea5e9',
                            marginBottom: '0.25rem'
                          }}>
                            {branding.projects}
                          </div>
                          <div style={{
                            fontSize: 'clamp(0.7rem, 1.5vw, 0.75rem)',
                            color: '#64748b',
                            fontWeight: '600'
                          }}>
                            Projects
                          </div>
                        </div>
                        <div style={{
                          background: 'rgba(14, 165, 233, 0.08)',
                          border: '1px solid rgba(14, 165, 233, 0.2)',
                          borderRadius: 'clamp(8px, 2vw, 12px)',
                          padding: 'clamp(0.75rem, 2vw, 1rem)',
                          textAlign: 'center'
                        }}>
                          <div style={{
                            fontSize: 'clamp(1rem, 2.5vw, 1.1rem)',
                            fontWeight: '700',
                            color: '#0ea5e9',
                            marginBottom: '0.25rem'
                          }}>
                            {branding.avgROI}
                          </div>
                          <div style={{
                            fontSize: 'clamp(0.7rem, 1.5vw, 0.75rem)',
                            color: '#64748b',
                            fontWeight: '600'
                          }}>
                            Avg ROI
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Row 5: Key Stats Preview */}
                    <div style={{
                      minHeight: 'clamp(40px, 8vw, 50px)',
                      display: 'flex',
                      alignItems: 'center',
                      flexShrink: 0
                    }}>
                      <div style={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: 'clamp(0.25rem, 1vw, 0.5rem)',
                        width: '100%'
                      }}>
                        {industry.stats.slice(0, 2).map((stat, index) => (
                          <div key={index} style={{
                            background: 'rgba(14, 165, 233, 0.1)',
                            border: '1px solid rgba(14, 165, 233, 0.2)',
                            borderRadius: 'clamp(6px, 1.5vw, 8px)',
                            padding: 'clamp(0.3rem, 1vw, 0.4rem) clamp(0.6rem, 2vw, 0.8rem)',
                            fontSize: 'clamp(0.7rem, 1.8vw, 0.8rem)',
                            fontWeight: '600',
                            color: '#0ea5e9'
                          }}>
                            <span style={{ fontWeight: '700' }}>{stat.number}</span> {stat.label}
                          </div>
                        ))}
                      </div>
                    </div>

                    {/* Row 6: CTA Button - Pushed to bottom */}
                    <div style={{ 
                      marginTop: 'auto',
                      flexShrink: 0,
                      paddingTop: 'clamp(0.5rem, 1.5vw, 1rem)'
                    }}>
                      <button 
                        style={{
                          width: '100%',
                          background: 'linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%)',
                          border: 'none',
                          color: '#ffffff',
                          padding: 'clamp(0.6rem, 2vw, 0.75rem) clamp(1rem, 3vw, 1.5rem)',
                          borderRadius: 'clamp(8px, 2vw, 12px)',
                          fontWeight: '700',
                          fontSize: 'clamp(0.8rem, 2vw, 0.9rem)',
                          cursor: 'pointer',
                          transition: 'all 0.3s ease',
                          boxShadow: '0 4px 15px rgba(14, 165, 233, 0.3)',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          gap: 'clamp(0.25rem, 1vw, 0.5rem)',
                          minHeight: 'clamp(40px, 8vw, 50px)'
                        }}
                        onMouseEnter={(e) => {
                          e.target.style.transform = 'translateY(-2px)';
                          e.target.style.boxShadow = '0 8px 25px rgba(14, 165, 233, 0.4)';
                          e.target.style.background = 'linear-gradient(135deg, #0284c7 0%, #0369a1 100%)';
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.transform = 'translateY(0)';
                          e.target.style.boxShadow = '0 4px 15px rgba(14, 165, 233, 0.3)';
                          e.target.style.background = 'linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%)';
                        }}
                        onClick={() => navigate(`/industries/${industry.id}`)}
                      >
                        <span>Explore {industry.title}</span>
                        <i className="bi bi-arrow-right" style={{ fontSize: 'clamp(0.8rem, 2vw, 0.9rem)' }}></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* Industry Comparison CTA */}
        <div className="row justify-content-center mt-5">
          <div className="col-lg-8 text-center">
            <div style={{
              background: 'rgba(255, 255, 255, 0.9)',
              backdropFilter: 'blur(20px)',
              border: '1px solid rgba(14, 165, 233, 0.2)',
              borderRadius: 'clamp(16px, 3vw, 24px)',
              padding: 'clamp(1.5rem, 4vw, 3rem)',
              marginTop: '2rem',
              boxShadow: '0 8px 30px rgba(0, 0, 0, 0.06)'
            }}>
              <h4 style={{
                fontSize: 'clamp(1.2rem, 3vw, 1.5rem)',
                fontWeight: '700',
                color: '#1e293b',
                marginBottom: '1.5rem'
              }}>
                Need to Compare Industries?
              </h4>
              <p style={{
                color: '#64748b',
                marginBottom: '2rem',
                fontSize: 'clamp(1rem, 2.5vw, 1.1rem)',
                lineHeight: '1.6'
              }}>
                Get detailed insights into AI adoption rates, ROI potential, and implementation timelines across different sectors.
              </p>
              <button 
                style={{
                  background: 'linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%)',
                  border: 'none',
                  color: '#ffffff',
                  padding: 'clamp(0.8rem, 2vw, 1rem) clamp(1.5rem, 4vw, 2rem)',
                  borderRadius: 'clamp(12px, 2.5vw, 16px)',
                  fontWeight: '700',
                  fontSize: 'clamp(0.9rem, 2vw, 1rem)',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  boxShadow: '0 8px 25px rgba(14, 165, 233, 0.3)'
                }}
                onMouseEnter={(e) => {
                  e.target.style.transform = 'translateY(-2px)';
                  e.target.style.boxShadow = '0 12px 35px rgba(14, 165, 233, 0.4)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.transform = 'translateY(0)';
                  e.target.style.boxShadow = '0 8px 25px rgba(14, 165, 233, 0.3)';
                }}
                onClick={() => navigate('/industries/comparison')}
              >
                Compare Industries
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Industries; 